import { PdfViewerPageClasses } from './../components/PdfViewer/components/pdf-viewer-page/pdf-viewer-page.component.type';
export var SwipeDirection;
(function (SwipeDirection) {
    SwipeDirection["Left"] = "left";
    SwipeDirection["Right"] = "right";
})(SwipeDirection || (SwipeDirection = {}));
export const SWIPE_THRESHOLD = 20;
const interactiveElements = ['input', 'textarea', 'button', 'select', 'option', 'optgroup', 'datalist', 'canvas'];
export const targetElementIsInteractive = (event) => {
    const target = event && event.target;
    const annotatingClass = `.${PdfViewerPageClasses.IsAnnotating}`;
    if (target.closest && target.closest(annotatingClass)) {
        return true;
    }
    const tagName = ((target && target.tagName) || '').toLowerCase();
    return interactiveElements.indexOf(tagName) !== -1;
};
export const hasSelection = (element) => {
    const selection = document.getSelection();
    return (!!selection &&
        selection.anchorOffset !== selection.focusOffset &&
        (element.contains(selection.anchorNode) ||
            element.contains(selection.focusNode) ||
            element === selection.anchorNode ||
            element === selection.focusNode));
};
export const mouseEventToCoordinates = (mouseEvent) => {
    return {
        x: mouseEvent.clientX,
        y: mouseEvent.clientY
    };
};
export const touchEventToCoordinates = (touchEvent) => {
    return {
        x: touchEvent.changedTouches[0].clientX,
        y: touchEvent.changedTouches[0].clientY
    };
};
//# sourceMappingURL=SwipeHelper.js.map